<template>
	    <footer class='footer' v-if="$route.meta.onlyAuthUser !== true">
      <div class='footer-main cbiz-bg section'>
        <div class='container'>    
          <div class='row'>
            <div class='widgets'>
              <div class='col-xs-12 col-sm-12 col-md-4'>
                <div class='widget logo'>
                  <div class='wi-title'>
                  </div>
                  <div class='wi-content'>
                    <p>InCube offers unique best in class software, countless top of the line mobile hardware and the most trust worthy expertise in the technological supply chain and logistics industry. We welcome all to the InCube Family as a client, reseller and partner..</p>
                    <ul class='wi-list'>
                      <li>
                        <a href='https://www.google.com/maps/dir//incube+canada/@31.8884726,-58.5029238,3z/data=!4m9!4m8!1m0!1m5!1m1!1s0x882b5da35041677b:0xab163db0dbdd074e!2m2!1d-79.7125496!2d43.4323939!3e4'><i aria-hidden='true' class='fa fa-map-marker'/>Get Directions</a>
                      </li>
                      <li>
                        <a href='mailto:info.Canada@e-incube.com'><i class='fa fa-envelope-o'/>marketing@e-incube.ca</a>
                      </li>
                      <li>
                        <a href='tel:+1905-465-9696'><i class='fa fa-phone'/>+1 (905) 465-9696 </a>
                      </li>

                    </ul>
                  </div>
                </div> <!-- /.widget -->
              </div> <!-- /.col- -->
              <div class='col-xs-12 col-sm-12 col-md-4'>
                <div class='widget'>
                  <div class='wi-title'>
                     <h5>Popular Tags</h5>
                  </div>
                  <div class='wi-content wi-tags'>
                    <ul>
                      <li><a >Printek </a></li>
                      <li><a >Datalogic</a></li>
                      <li><a >IT solutions</a></li>
                      <li><a >Supply chain solutions</a></li>
                      <li><a >grocery innovations canada</a></li>
                      <li><a >Solutions</a></li>
                      <li><a >warehouse management system </a></li>
                      <li><a >scanner in Canada</a></li>
                      <li><a >inventory counting</a></li>
                      <li><a >printers </a></li>
                      <li><a >mobility solutions</a></li>
                      <li><a >sales and distribution </a></li>
                      <li><a >van sales </a></li>
                      <li><a >food safety </a></li>
                      <li><a >food inspection agency</a></li>
                      <li><a >cfia canada</a></li>
                    </ul>
                  </div> <!-- /.wi-content -->
                </div> <!-- /.widget -->
                <div class='widget'>
                  <div class='wi-title'>
                     <h5>Follow Us</h5>
                  </div>
                  <div class='wi-content wi-social'>
                    <ul>
                      <li>
                        <a href='https://www.facebook.com/InCubeMobility' target="_blank">
                          <i class='fa normal-show fa-facebook'/>
                          <i class='fa hover-show fa-facebook'/>
                        </a>
                      </li>
                      <li>
                        <a href='https://www.linkedin.com/company/incube-mobility-solutions' target="_blank">
                          <i class='fa normal-show fa-linkedin'/>
                          <i class='fa hover-show fa-linkedin'/>
                        </a>
                      </li>
                    </ul>
                  </div> <!-- /.wi-content -->
                </div> <!-- /.widget -->
              </div> <!-- /.col- -->
              <div class='col-xs-12 col-sm-12 col-md-4'>
                                  <div class='wi-title'>
                     <h5>Our Visitor</h5>
                  </div>
<form ref="myform"/>

              </div>
            </div> <!-- /.widgets -->
          </div> <!-- /.row -->  
        </div> <!-- /.container -->
      </div> <!-- /.footer-main -->
      <div class='copyright'>
        <div class='container'>
          InCubeMobility | {{GetCurrentYear()}} All rights reserved. Terms of use and Privacy Policy
        </div>
      </div> <!-- /.copyright -->
    </footer> <!-- /.footer -->
</template>

<script >
  export default {
 mounted() {
    let externalScript = document.createElement('script')
    externalScript.setAttribute('src', '//rf.revolvermaps.com/0/0/8.js?i=5s7cshaacm1&amp;m=0&amp;c=9d8b63&amp;cr1=ff0000&amp;f=arial&amp;l=33&amp;as=100')
    this.$refs.myform.appendChild(externalScript)
  },
  methods :{
    GetCurrentYear(){
      return new Date().getFullYear();
    }
  }
  }
</script>